module.exports = __webpack_public_path__ + "static/media/background.c059f8d9.png";